export enum OtherAccountTypeEnum {
  GOOGLE,
  OUTLOOK,
}
